module.exports = { "default": require("core-js/library/fn/object/is"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/core-js/object/is.js
// module id = 1181
// module chunks = 1